import styles from './NewProject.module.css'
import { useNavigate } from 'react-router-dom'
import ProjectForm from '../project/ProjectForm'
function NewProject(){

    const navigate = useNavigate()

    function createPost(project){
        fetch(`${process.env.REACT_APP_API_URL}/projects`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(project),
        }).then((resp) => resp.json())
        .then((data) => {
            console.log(data)
            navigate('/projects')
        })
        .catch((err) => console.log(err))
    }
    return (
        <div className={styles.newproject_container}>
            <h1>Criar Projeto</h1>
            <p>Crie seu projeto para depois adicionar os serviços</p>
            <ProjectForm handleSubmit={createPost} btnText="Criar Projeto"/>       
             </div>
    )
}
export default NewProject